import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import { PlatformClient } from '../httpClients/PlatformClient/PlatformClient';
import { QUERY_KEYS } from '../queries/consts';
import { queryClient } from '../queryClient';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

export const useDeleteMemberMutation = () => {
  const spawnToasts = spawn('toasts.organization.delete-member');

  return useMutation({
    mutationKey: [MUTATION_KEYS.DELETE_MEMBER],
    mutationFn: async (userId: string) => {
      return await PlatformClient.deleteMember(userId);
    },
    onSuccess: () => {
      toast.success(spawnToasts('success'));
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.ORGANIZATION_MEMBERS],
      });
    },
    onError: (err: any) => {
      const errorFromServer = getErrorToastContent(err, spawnToasts('error'));

      toast.error(errorFromServer);
    },
  });
};
